import { useContext, useEffect, useRef } from "react";
import { Modal } from "antd";
import { mainContext } from "@ts/constants";
import { getCurrentFilterDOM } from "@ts/utils";
import { GridApi } from "ag-grid-community";
import { IMainContext } from "@ts/common-types";
import { AiOutlineClose } from "react-icons/ai";
import React from "react";
interface IProps {
    api: GridApi;
}

const RulesFilterModal: React.FC<IProps> = ({ api }) => {
    const { rulesFilterDisp, setRulesFilterDisp, rulesFilterData } =
        useContext<IMainContext>(mainContext);
    const filterBodyRef = useRef<HTMLDivElement | null>(null);

    const handleClose = () => {
        setRulesFilterDisp(false);
    };

    useEffect(() => {
        if (rulesFilterDisp && rulesFilterData) {
            const filterBody = filterBodyRef.current;
            if (filterBody) {
                filterBody.appendChild(
                    getCurrentFilterDOM(
                        api,
                        rulesFilterData.filter,
                        true,
                        false
                    )
                );
            }
        }
    }, [rulesFilterDisp, rulesFilterData, api]);

    return (
        <>
            {rulesFilterDisp ? (
                <Modal
                    title={
                        <div className="d-flex align-items-center pb-3">
                            <h4>{rulesFilterData?.name || ""}</h4>
                        </div>
                    }
                    style={{ top: 50 }}
                    styles={{ body: { minHeight: "50px" } }}
                    open={rulesFilterDisp}
                    onCancel={handleClose}
                    closeIcon={<AiOutlineClose style={{ fontSize: "40px" }} />}
                    footer={null}
                >
                    <div
                        ref={filterBodyRef}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                        }}
                    ></div>
                </Modal>
            ) : null}
        </>
    );
};

export default RulesFilterModal;
